<template>
  <b-modal
    id="f-detail"
    no-close-on-backdrop
    centered
    size="lg"
    v-model="showModal"
    :title="is_edit ? 'Update ORI' : 'Create ORI'"
  >
    <div class="ori-form">

      <div class="form-row-2">
        <div class="form-group">
          <label>ORI Number <span class="req">*</span></label>
          <input type="text" class="field" v-model="serviceori.ori_number"
            :class="{ 'field-err': errors['ori_number'] }"
            placeholder="e.g. FL0010000" />
          <span v-if="errors['ori_number']" class="err-msg">{{ errors["ori_number"][0] }}</span>
        </div>

        <div class="form-group">
          <label>Requires Photograph</label>
          <div class="toggle-row">
            <div class="toggle-info">
              <div class="toggle-label">{{ serviceori.requires_photograph ? 'Required' : 'Not required' }}</div>
            </div>
            <button type="button" class="toggle-btn" :class="{ on: serviceori.requires_photograph }"
              @click="serviceori.requires_photograph = !serviceori.requires_photograph">
              <span class="toggle-knob"></span>
            </button>
          </div>
        </div>
      </div>

      <div class="form-row-2">
        <div class="form-group">
          <label>Profession <span class="req">*</span></label>
          <input type="text" class="field" v-model="serviceori.profession"
            :class="{ 'field-err': errors['profession'] }"
            placeholder="e.g. Teacher" />
          <span v-if="errors['profession']" class="err-msg">{{ errors["profession"][0] }}</span>
        </div>

        <div class="form-group">
          <label>Service <span class="req">*</span></label>
          <select class="field field-select" v-model="serviceori.service_code">
            <option value="">Select Service</option>
            <option v-for="(item, index) in getServiceCodeData.data" :key="index" :value="item.id">
              {{ item.service_name }}
            </option>
          </select>
          <span v-if="errors['service_code']" class="err-msg">{{ errors["service_code"][0] }}</span>
        </div>
      </div>

      <div class="form-row-2">
        <div class="form-group">
          <label>Actual Rate <span class="req">*</span></label>
          <div class="unit-wrap" :class="{ 'unit-wrap-err': errors['our_rate'] }">
            <span class="unit-prefix">$</span>
            <input type="number" class="unit-field" v-model="serviceori.our_rate" min="0" placeholder="0.00" />
          </div>
          <span v-if="errors['our_rate']" class="err-msg">{{ errors["our_rate"][0] }}</span>
        </div>

        <div class="form-group">
          <label>Transaction Type</label>
          <select class="field field-select" v-model="serviceori.transaction_type">
            <option value="">Select Transaction Type</option>
            <option value="MAP">MAP</option>
            <option value="NFUF">NFUF</option>
          </select>
        </div>
      </div>

    </div>

    <template #modal-footer>
      <div class="modal-foot">
        <button class="foot-btn foot-cancel" @click="close()">
          Cancel
        </button>
        <div class="foot-right">
          <button
            v-if="!is_edit"
            ref="kt_save_add_another_company"
            class="foot-btn foot-saa"
            @click="store('SAA', 'kt_save_add_another_company')"
          >
            Save &amp; Add Another
          </button>
          <button
            v-if="!is_edit"
            ref="kt_save_company"
            class="foot-btn foot-save"
            @click="store('S', 'kt_save_company')"
          >
            <i class="fa fa-check"></i> Save
          </button>
          <button
            v-if="is_edit"
            ref="kt_update_company_data"
            class="foot-btn foot-save"
            @click="store('Update', 'kt_update_company_data')"
          >
            <i class="fa fa-check"></i> Update
          </button>
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";
import { CREATE_SERVICEORI } from "@/core/services/store/actions.type";

export default {
  props: {
    showModal:   { type: Boolean, default: false },
    is_edit:     { type: Boolean, default: false },
    serviceori:  {
      type: Object,
      default: () => ({
        ori_number: "", id: 0, profession: "",
        requires_photograph: false, service_code: "",
        our_rate: "", transaction_type: ""
      })
    }
  },
  data() {
    return { errors: [] };
  },
  computed: { ...mapGetters(["getServiceCodeData"]) },
  methods: {
    close() { this.$emit("closemodal"); },
    clearForm() {
      this.serviceori.ori_number     = "";
      this.serviceori.id             = 0;
      this.serviceori.profession     = "";
      this.serviceori.our_rate       = "";
      this.serviceori.transaction_type = "";
    },
    store(saveType, ref) {
      const btn = this.$refs[ref];
      btn.disabled = true;
      btn.classList.add("spinner", "spinner-light", "spinner-right");
      this.$store.dispatch(CREATE_SERVICEORI, this.serviceori)
        .then(data => {
          this.closeBtnLoad(ref);
          if (!this.is_edit) {
            if (saveType === "S") {
              this.$toastr.s(data.msg);
              this.$emit("closemodal");
            } else if (saveType === "SAA") {
              this.$toastr.s(data.msg);
              this.clearForm();
            }
          } else {
            this.$toastr.s("ORI successfully updated");
            this.$emit("closemodal");
          }
        })
        .catch(err => {
          this.errors = err;
          this.closeBtnLoad(ref);
        });
    },
    closeBtnLoad(ref) {
      const btn = this.$refs[ref];
      btn.classList.remove("spinner", "spinner-light", "spinner-right");
      btn.disabled = false;
    }
  }
};
</script>

<style lang="scss">
$font:   'Segoe UI', sans-serif;
$blue:   #389ad4;
$green:  #276749;
$dark:   #0d1b3e;
$border: #dde2ec;

#f-detail {
  .modal-header {
    background: #fafbff;
    border-bottom: 1px solid #f0f3fa;
    padding: 16px 20px;
    .modal-title { font-size: 15px; font-weight: 700; color: $dark; font-family: $font; }
    .close { font-size: 20px; color: #8a94a6; }
  }
  .modal-body { padding: 24px 20px 8px; }
  .modal-footer { padding: 0; border-top: none; }
}
</style>

<style lang="scss" scoped>
$font:   'Segoe UI', sans-serif;
$blue:   #389ad4;
$green:  #276749;
$dark:   #0d1b3e;
$border: #dde2ec;

.ori-form { font-family: $font; }

.form-row-2 {
  display: grid; grid-template-columns: 1fr 1fr; gap: 16px;
  margin-bottom: 4px;
}

.form-group { margin-bottom: 16px; }

label {
  display: block; font-size: 11px; font-weight: 700;
  color: #4a5568; text-transform: uppercase; letter-spacing: 0.4px;
  margin-bottom: 6px;
}
.req { color: #e53e3e; }

.field {
  display: block; width: 100%; height: 38px;
  border: 1.5px solid $border; border-radius: 8px;
  padding: 0 12px;
  font-size: 13px; font-family: $font; color: $dark;
  background: #fff; outline: none;
  transition: border-color 0.15s; box-shadow: none;
  &:focus { border-color: $blue; }
  &.field-err { border-color: #e53e3e; }
}
.field-select {
  padding-right: 32px;
  background: #fff url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6'%3E%3Cpath d='M0 0l5 6 5-6z' fill='%23a0aab8'/%3E%3C/svg%3E") no-repeat right 12px center;
  appearance: none; cursor: pointer;
}

/* $ prefix input */
.unit-wrap {
  display: flex; border: 1.5px solid $border; border-radius: 8px;
  overflow: hidden; transition: border-color 0.15s;
  &:focus-within { border-color: $blue; }
  &.unit-wrap-err { border-color: #e53e3e; }
}
.unit-prefix {
  display: flex; align-items: center; padding: 0 10px;
  background: #f7f9fc; border-right: 1.5px solid $border;
  font-size: 13px; font-weight: 600; color: #6b7280;
}
.unit-field {
  border: none; flex: 1; height: 38px; padding: 0 10px;
  font-size: 13px; font-family: $font; color: $dark;
  outline: none; background: #fff;
}

.err-msg { font-size: 11px; color: #e53e3e; margin-top: 3px; display: block; }

/* Requires photograph toggle */
.toggle-row {
  display: flex; align-items: center; justify-content: space-between;
  padding: 8px 12px; background: #f7f9fc;
  border: 1.5px solid $border; border-radius: 8px; height: 38px;
}
.toggle-label { font-size: 13px; color: #4a5568; font-weight: 500; text-transform: none; letter-spacing: 0; }
.toggle-btn {
  position: relative; width: 40px; height: 22px; border-radius: 11px;
  border: none; cursor: pointer; background: #d1d5db;
  flex-shrink: 0; transition: background 0.2s;
  &.on { background: $blue; }
}
.toggle-knob {
  position: absolute; top: 2px; left: 2px;
  width: 18px; height: 18px; border-radius: 50%;
  background: #fff; box-shadow: 0 1px 3px rgba(0,0,0,0.2);
  transition: transform 0.2s;
  .toggle-btn.on & { transform: translateX(18px); }
}

/* Footer */
.modal-foot {
  display: flex; align-items: center; justify-content: space-between;
  padding: 14px 20px;
  border-top: 1px solid #f0f3fa;
  background: #fafbff;
  border-radius: 0 0 8px 8px;
  width: 100%;
}
.foot-right { display: flex; align-items: center; gap: 8px; }

.foot-btn {
  display: inline-flex; align-items: center; gap: 6px;
  height: 36px; padding: 0 18px; border-radius: 8px;
  font-size: 13px; font-weight: 600; font-family: $font; cursor: pointer;
  transition: background 0.15s, border-color 0.15s;
  i { font-size: 11px; }
}
.foot-cancel {
  border: 1.5px solid $border; background: transparent; color: #6b7280;
  &:hover { border-color: #c62828; color: #c62828; background: #fff5f5; }
}
.foot-saa {
  border: 1.5px solid $blue; background: transparent; color: $blue;
  &:hover { background: #eef7fb; }
  &:disabled { opacity: 0.6; cursor: default; }
}
.foot-save {
  border: none; background: $green; color: #fff;
  &:hover { background: #1d5230; }
  &:disabled { opacity: 0.6; cursor: default; }
}
</style>
